module.exports = __webpack_public_path__ + "img/matthieu_h.13f1a1ed.png";